import $ from "jquery";
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';


// 共通設定
const homeSwiper = '#js-home-swiper',
      param = {
        params: {
          breakpoints: {
            835: {
              centeredSlides: false,
              slidesPerView: 4,
            },
          },
          centeredSlides: true,
          spaceBetween: 33,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          slidesPerView: "auto",
        },
      };


// スライドの数を数える
let cnt = $(homeSwiper + " .swiper-slide").length;


let swiper;


if(cnt > 4) {
  swiper = new Swiper(homeSwiper, {
    breakpoints: {
      835: {
        centeredSlides: false,
        slidesPerView: 4,
      },
    },
    centeredSlides: true,
    loop: true,
    spaceBetween: 33,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    slidesPerView: "auto",
  });
} else {
  swiper = new Swiper(homeSwiper, {
    breakpoints: {
      835: {
        centeredSlides: false,
        slidesPerView: 4,
      },
    },
    centeredSlides: true,
    spaceBetween: 33,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    slidesPerView: "auto",
  });
}
